module.exports = __webpack_public_path__ + "static/fsa-93765ef17eee279a3a768fcc5ab3272e.jpeg";